import DmsSettings from 'pages/SettingsPage/Dms/DmsSettings';
export default DmsSettings;
